import type { QfwLibrarySearchPayload } from '~/types/apis/LibraryAPIService';
import $axios from '../AxiosService';
import { nanoid } from 'nanoid';
import Constants from '~/config/Constants';
import featureFlags from '~/services/FeatureFlagsService';

const LibraryService = {
  async getQuizzesCount() {
    const params = {
      likedQuizzes: true,
      hostedQuizzes: true,
      createdQuizzes: true,
      standardTaggedQuizzes: true,
      draftQuizzes: true,
      sharedQuizzes: true,
    };
    try {
      const response = await $axios().get('/search/v1/quizCountsByTag', { params });
      if (response.data.success) {
        return {
          ...response.data.data,
        };
      }
      return {
        success: false,
      };
    } catch (error) {
      return {
        success: false,
      };
    }
  },

  async getAutoCompleteResults(query = '', subject = '', userInfo = {}) {
    try {
      const featureInfo = {
        [Constants.FeatureFlagsTypes.BOOK_DISCOVERY_VARIATIONS]: featureFlags().getFeatureValue(Constants.FeatureFlagsTypes.BOOK_DISCOVERY_VARIATIONS, 'NOT_ELIGIBLE'),
        [Constants.FeatureFlagsTypes.BOOK_DISCOVERY]: featureFlags().isEnabled(Constants.FeatureFlagsTypes.BOOK_DISCOVERY),
      };
      const response = await $axios().post(`/getAutoComplete?searchTerm=${query}&subject=${subject}`, { searchTerm: query, subject, ...userInfo, featureInfo });
      if (response.data.success) {
        return response.data;
      }
      return null;
    } catch (err) {
      return null;
    }
  },

  async searchQfwQuizzes(args: QfwLibrarySearchPayload, signal: AbortSignal) {
    try {
      const {
        from = 0,
        size = 10,
        term,
        order = 'desc',
        sortKey = 'createdAt',
        personal = true,
        filterList = {
          type: [],
          tags: [],
        },
        draftQuizzes = false,
        publishedQuizzes,
        createdByMe = false,
        sharedWithMe = false,
        allQuizzes,
        createdBy,
        paidOrganizationId,
        queryId,
        query,
      } = args;

      const params = {
        from,
        size,
        term,
        order,
        sortKey,
        personal,
        filterList: JSON.stringify(filterList),
        draftQuizzes,
        publishedQuizzes,
        createdByMe,
        allQuizzes,
        createdBy,
        sharedWithMe,
        paidOrganizationId,
        queryId,
        query,
        _: nanoid(6),
      };
      const response = await $axios().get('/search/v1/private', {
        params,
        signal,
      });

      return response.data.data;
    } catch (err) {
      return null;
    }
  },

  async getAutoCompleteResultsForDiscovery(
    {
      searchTerm = '',
      subject = '',
      userId = '',
      sessionId = '',
      allowSkills = false,
      log = true,
    },
    signal: AbortSignal | null = null,
  ) {
    try {
      const featureInfo = {
        [Constants.FeatureFlagsTypes.BOOK_DISCOVERY_VARIATIONS]: featureFlags().getFeatureValue(Constants.FeatureFlagsTypes.BOOK_DISCOVERY_VARIATIONS, 'NOT_ELIGIBLE'),
        [Constants.FeatureFlagsTypes.BOOK_DISCOVERY]: featureFlags().isEnabled(Constants.FeatureFlagsTypes.BOOK_DISCOVERY),
      };
      const response = await $axios().post('/getAutoCompleteDiscovery',
        {
          searchTerm,
          subject,
          userId,
          sessionId,
          allowSkills,
          log,
          featureInfo,
        },
        { ...(signal !== null ? { signal } : {}) },
      );
      if (response.data.success) {
        return response.data;
      }
      return null;
    } catch (err) {
      return null;
    }
  },

  async getQfwOrgQuizzes(args: {
    query?: string,
    from?: number,
    size?: number,
    sortKey?: string,
    order?: string,
    type?: string[],
    paidOrganizationId: string,
    createdBy: string[],
  }, signal: AbortSignal) {
    try {
      const response = await $axios().get('/corporate/orgLibrary', {
        params: args,
        signal,
      });
      return response.data.data;
    } catch (err) {
      return null;
    }
  },
};

export default LibraryService;
